import React from 'react';
import { Box, Icon, Typography } from '@mui/material';
import { get } from 'global/lib/lodash';
import { Row } from 'global/components/row';
import { getRealmIcon } from 'global/components/droprealms';
import { FlexGridIconLabel } from 'global/components/flex-grid-list';

/** Editions / scorecards title with optional parent tree marker. */
export function ParentNameCell({ row, children }) {
  return (
    <Row>
      {row.parent && <Icon className="parentIcon">keyboard_return</Icon>}
      {children ?? get(row, 'name')}
    </Row>
  );
}

/** Shared Access column: realms (+ icons) and user group names. */
export function AccessCell({ row }) {
  const realms = get(row, 'realms', []) || [];
  const userGroupNames = (get(row, 'userGroups', []) || []).map((u) => u.name).join(', ');
  return (
    <div>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        {realms.map((r, i) => {
          const name = get(r, 'name', '');
          return (
            <FlexGridIconLabel
              key={r.id ?? `${r.tier}-${name}-${i}`}
              icon={getRealmIcon(r)}
              title={name}
              noWrap={false}
              sx={row.isShared ? { fontStyle: 'italic' } : undefined}
            >
              {name}
            </FlexGridIconLabel>
          );
        })}
      </Box>
      {!!userGroupNames && (
        <Typography variant="body2">{userGroupNames}</Typography>
      )}
    </div>
  );
}
